import { TOTAL_STEPS } from "../constants";

/** One segment. The bar's mini strip is 4px tall, the panel's 5px. */
function segClass(index: number, step: number, mini: boolean): string {
  const n = index + 1;
  const height = mini ? "h-[4px]" : "h-[5px]";
  const tone = n < step ? "bg-white/[0.42]" : n === step ? "bg-[#00A58D]" : "bg-white/[0.14]";
  return `flex-1 rounded-sm ${height} ${tone}`;
}

type Props = {
  step: number;
  /** the collapsed-bar variant: shorter, and it must not stretch the bar */
  mini?: boolean;
};

export function ProgressStrip({ step, mini = false }: Props) {
  return (
    <div className={mini ? "flex gap-[3px] flex-none" : "flex gap-[3px]"}>
      {Array.from({ length: TOTAL_STEPS }, (_, i) => (
        <span key={i} className={segClass(i, step, mini)} />
      ))}
    </div>
  );
}
